// extracted by mini-css-extract-plugin
export default {"typography":"Typography_typography__Ed3R-","typography--cropped":"Typography_typography--cropped__6O3Tj"};